import { styled, StyledButton } from '@raskrask-dk/rr-components'

export const StyledCodeField = styled('div', {
    bgc: '$primary200',
    br: '$1',
    display: 'grid',
    gap: '$2',
    mt: '-$1',
    p: '$2',
})

export const StyledCode = styled('div', {
    [`& ${StyledButton}`]: {
        bgc: '$white',
        border: '1px solid $primary600',
        color: '$primary600',
        position: 'relative',
        w: '100%',

        '&:after': {
            borderLeft: '8px solid rgba(255, 255, 255, 0)',
            borderRight: '8px solid rgba(255, 255, 255, 0)',
            borderTop: '8px solid $primary600',
            content: `''`,
            left: '50%',
            position: 'absolute',
            top: '100%',
            transform: 'translateX(-50%)',
            transition: '0.2s cubic-bezier(0.785, 0.135, 0.150, 0.860)',
        },

        '&:hover': {
            bc: '$primary600',
            bgc: '$primary600',
            color: '$white',
        },

        svg: {
            color: '$primary400',
            cursor: 'pointer',
            position: 'absolute',
            right: 4,
            size: 14,
            top: 4,
            transition: '$default',
            zIndex: 1,
        },
    },

    variants: {
        active: {
            true: {
                [`& ${StyledButton}`]: {
                    bc: '$primary600',
                    bgc: '$primary600',
                    color: '$white',

                    '&:after': { display: 'block' },

                    svg: {
                        opacity: 1,
                        transform: 'scale(1)',
                    },
                },
            },
            false: {
                [`& ${StyledButton}`]: {
                    '&:after': { display: 'none' },

                    svg: {
                        opacity: 0,
                        transform: 'scale(0.5)',
                    },
                },
            },
        },
        disabled: {
            true: {
                [`& ${StyledButton}`]: {
                    bc: '$primary400',
                    bgc: '$white',
                    color: '$primary400',
                    cursor: 'default',

                    '&:hover': {
                        bc: '$primary400',
                        bgc: '$white',
                        color: '$primary400',
                    },
                },
            },
        },
    },
})

export const AddedCode = styled('div', {
    br: '$1',
    bgc: '$primary200',
    display: 'grid',
    gap: '$1',
    padding: '$2 $3',
    position: 'relative',
})

export const StyledCodes = styled('div', {
    display: 'grid',
    gap: '$2',
    gridAutoFlow: 'column',
})
